import { Spacer } from "@/components/Spacer";
import { motion } from "framer-motion";
import { useEffect, useState } from "react";

export default function Section07({ isMobile }: { isMobile: boolean }) {
  return (
    <div className="w-full flex flex-col items-center bg-[#F5F6FA] desktop:py-[160px] desktop:px-[20px] py-[80px] px-[24px]">
      <motion.div
        id="w-01"
        className="desktop:w-[960px] w-[342px] flex flex-col relative"
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.5 }}
        transition={{
          type: "spring",
          stiffness: 300,
          damping: 100,
          mass: 1,
          delay: 0.1,
        }}
      >
        <img
          src="assets/images/section-07-01-desktop-eng.png"
          alt="section-07-01"
          className="desktop:w-[634px] desktop:h-[422px] w-full h-[228px]"
        />
        <Spacer height={isMobile ? 24 : 100} />
        <div
          className="font-eng-01-semibold text-[#5364F2] leading-[100%] desktop:text-[18px] text-[13px] text-start"
          style={{ letterSpacing: "-0.02em" }}
        >
          Tired of Waiting at the Hospital?
        </div>
        <Spacer height={12} />
        <div
          className="font-eng-01-semibold text-[#17191C] leading-[130%] desktop:text-[32px] text-[20px] text-start"
          style={{ letterSpacing: "-0.03em" }}
        >
          Share your health information
          <br /> in advance and get faster care.
        </div>
        <Spacer height={16} />
        <div
          className="font-eng-regular text-[#2E323A] desktop:leading-[130%] leading-[140%] desktop:text-[15px] text-[14px] text-start"
          style={{ letterSpacing: "-0.04em" }}
        >
          Healthier automatically generates a medical chart based on your AI
          <br className="desktop:block hidden" />
          symptom analysis.
          <Spacer height={isMobile ? 4 : 8} />
          This chart can be sent to your doctor ahead of time for quicker and
          <br className="desktop:block hidden" />
          more accurate consultations.
        </div>

        <img
          src="assets/images/section-07-02-desktop-eng.png"
          alt="section-07-02"
          className="desktop:w-[723px] desktop:h-[540px] overflow-visible desktop:absolute desktop:left-[516px] desktop:bottom-[0px] desktop:block hidden"
        />
      </motion.div>

      <Spacer height={isMobile ? 40 : 80} />
      <motion.div
        id="w-02"
        className="desktop:w-[960px] w-[342px] flex desktop:flex-row flex-col desktop:gap-[20px]"
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.5 }}
        transition={{
          type: "spring",
          stiffness: 300,
          damping: 100,
          mass: 1,
          delay: 0.1,
        }}
      >
        <div className="desktop:w-[635px]w-full">
          <img
            src="assets/images/section-07-03-dekstop.png"
            alt="section-07-03"
            className="desktop:w-[635px] desktop:h-[425px] w-full h-[229px]"
          />
          <Spacer height={isMobile ? 16 : 24} />
          <div
            className="font-eng-01-semibold text-[#17191C] leading-[130%] desktop:text-[32px] text-[22px] text-start"
            style={{ letterSpacing: "-0.03em" }}
          >
            It’s easy to use for both patients
            <br /> and healthcare providers.
            <Spacer height={isMobile ? 40 : 161} />
          </div>
        </div>
        <div className="desktop:w-[305px] w-full flex desktop:flex-col flex-row desktop:justify-end gap-[16px]">
          <img
            src="assets/images/section-07-04-desktop-eng.png"
            alt="section-07-04"
            className="desktop:w-[305px] desktop:h-[435px] w-[194px] h-[276px]"
          />
          <div
            className="desktop:w-max font-eng-regular text-[#2E323A] desktop:leading-[130%] leading-[140%] desktop:text-[16px] text-[15px] text-start"
            style={{ letterSpacing: "-0.04em" }}
          >
            Doctors can view waiting or scheduled
            <br className="desktop:block hidden" /> patients and access each
            patient’s initial
            <br className="desktop:block hidden" /> chart before the visit.
          </div>
        </div>
      </motion.div>
    </div>
  );
}
